import { render, staticRenderFns } from "./todoForm.vue?vue&type=template&id=4daba120&"
import script from "./todoForm.vue?vue&type=script&lang=ts&"
export * from "./todoForm.vue?vue&type=script&lang=ts&"
import style0 from "./todoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports